<!-- Chọn mẫu hợp đồng -->
<h6 class="row" style="padding-left: 1em; padding-right: 1em" *ngIf="!isShowStep">
  <div class="drd-container col-12">
    <br />
    <h3 style="color: #005e5b">
      {{ "contract_lot.title_create_lot" | translate }}
    </h3>
    <br />
    <button #btnForm mat-stroked-button class="ml-2" color="primary" type="button" [ngStyle]="{ color: null }"
      [ngClass]="{ active_document: false }" (click)="onSelectedFormClick()" id="btnSelectTemplate">
      <mat-icon class="mr-0">book</mat-icon>
      {{ "button.document_form" | translate }}
    </button>
    <br /><br />
  </div>
</h6>

<!--Tạo lô hợp đồng-->
<mat-card *ngIf="isShowStep">
  <form>
    <mat-card-header>
      <mat-card-title class="mat-card-title-custom">
        <span *ngIf="viewMode === 'create'">{{ "title.create_lot_moha" | translate }}</span>
        <span *ngIf="viewMode === 'view'">{{ "title.view_lot_moha" | translate }}</span>
      </mat-card-title>
    </mat-card-header>
    <mat-card-content class="mb-3 mat-card-content-contract-sm">
      <mat-accordion #accordion="matAccordion" [multi]="true">
        <mat-expansion-panel [expanded]="viewMode !== 'view'" class="mb-3 mt-3">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.infor_template_lot" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="form-group row">
            <div class="col-12">
              <table>
                <tr>
                  <td>{{ "contract_lot.template_name" | translate }}</td>
                  <td>
                    <span [matTooltip]="documentTypeEnterprise?.name">{{ documentTypeEnterprise?.name }}</span>
                  </td>
                  <td class="d-flex justify-content-end">
                    <button class="ml-4 mr-2 custom-button-icon" mat-stroked-button color="primary" type="button"
                      (click)="preview()">
                      <mat-icon class="mr-0" style="
                          vertical-align: middle;
                          width: auto;
                          height: auto;
                        ">visibility</mat-icon>
                      {{ "button.preview_template_file" | translate }}
                    </button>
                  </td>
                  <td *ngIf="viewMode == 'create'">
                    <button mat-stroked-button color="primary" type="button" (click)="onSelectedFormClick()"
                      style="padding: 0 20px">
                      <mat-icon class="mr-0" style="
                          vertical-align: middle;
                          width: auto;
                          height: auto;
                        ">swap_horiz</mat-icon>
                      {{ "button.reselect_template" | translate }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <td>{{'headertable.document_type' | translate}}</td>
                  <td>{{serviceType?.name}}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr>
                  <td colspan="4">
                    <div style="display: block; height: 10px; width: 100%"></div>
                  </td>
                </tr>
                <tr>
                  <td>{{"add_document_moha.labor_contract_type" | translate}}</td>
                  <td>{{documentTypeEnterprise.laborContractType}}</td>
                  <td></td>
                  <td></td>
                </tr>

                <tr>
                  <td>
                    <div>{{'add_document_moha.customer_count_in_batch' | translate}}</div>
                  </td>
                  <td>
                    <nz-input-number
                      class="td-nz-input"
                      [(ngModel)]="maxNumberOfCustomerInFlow"
                      [nzMin]="1"
                      (ngModelChange)="onChangeFile($event)"
                      [ngModelOptions]="{ standalone: true }"
                      [disabled]="viewMode === 'view' || isContainCustomerSignature"
                    >
                    </nz-input-number>
                  </td>
                </tr>

                <tr>
                  <td>
                    {{ "contract_lot.upload_data" | translate }}
                    <span style="color: #fc1203">*</span>
                  </td>
                  <td colspan="2" *ngIf="fileName" style="max-width: 75vw;">
                    <span class="file-name" [class.error-file]="errorFile" style="word-break: break-word">{{
                      fileName
                      }}</span>
                  </td>
                  <td *ngIf="viewMode == 'create'">
                    <input type="file" id="file" name="file" style="display: none" (change)="onChangeFile($event)"
                      accept=".xlsx" onclick="this.value = null" />
                    <button mat-raised-button color="primary" type="button" (click)="uploadFile()" *ngIf="!fileName">
                      <mat-icon class="mr-0" style="
                          vertical-align: middle;
                          width: auto;
                          height: auto;
                        ">cloud_upload</mat-icon>
                      {{ "button.choose_file" | translate }}
                    </button>
                    <button color="primary" mat-stroked-button type="button" (click)="uploadFile()" *ngIf="fileName">
                      <mat-icon class="mr-0" style="
                          vertical-align: middle;
                          width: auto;
                          height: auto;
                        ">cloud_upload</mat-icon>
                      {{ "button.choose_another_file" | translate }}
                    </button>
                  </td>
                </tr>
                <tr>
                  <th>
                    <span
                      style="
                        font-weight: 600;
                        white-space: no-wrap;
                        font-size: 12px;
                      " class="mr-4">(
                      <a (click)="downloadFileTemplate()" class="file-name" style="text-decoration: underline;">{{
                        "contract_lot.note_for_upload" | translate
                        }}</a>)
                    </span>
                  </th>
                  <td colspan="3">
                    <i style="font-size: 12px;">{{
                      "validation.validate_file_type_file_size_lot" | translate
                      }}</i>
                  </td>
                </tr>
                <tr class="pt-5"></tr>
                <tr *ngIf="cecaEnable">
                  <td colspan="4">
                    <div style="display: block; height: 15px; width: 100%"></div>
                  </td>
                </tr>
                <!-- <tr *ngIf="cecaEnable && !isNotAttestedUser">
                  <td>
                    <span>
                      {{'contract_lot.identify_contract_BCT' | translate}}
                    </span>
                  </td>
                  <td colspan="3">
                    <mat-checkbox [(ngModel)]="checked" [ngModelOptions]="{standalone: true}" color="primary"
                      [disableRipple]="true" (click)="$event.preventDefault()"></mat-checkbox>
                    <span class="pl-3">
                      {{'contract_lot.is_confirm_BCT' | translate}}
                    </span>
                  </td>
                </tr> -->
                <tr *ngIf="!id">
                  <td>
                    <span>
                      <strong>{{'service_type.remind_configuration.note' | translate}}</strong>
                    </span>
                  </td>
                  <td>
                    <span class="text-title" *ngIf="isBuyContract1Mb && isBuyContract10Mb">- {{'contract_lot.documents_is_not_enough' | translate}}
                    </span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <!--Upload file-->
          <!-- <div class="row pb-4">
            <div class="col-12"></div>
            <div style="position: relative" class="col-12"></div>
            <div class="col-12">
              <span style="font-size: medium; font-weight: 600; opacity: 0"
                >{{ "contract_lot.upload_data" | translate }}
                <span style="color: #fc1203">*</span></span
              >
            </div>
          </div> -->

        </mat-expansion-panel>

        <mat-expansion-panel [expanded]="viewMode !== 'view'" class="mb-3" #expansionData>
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title">
              {{ "title.setting_lot" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-tab-group [selectedIndex]="currentTab" (selectedIndexChange)="currentTab = $event" (selectedTabChange)="openTabSign($event)">
            <!--Cấu hình luồng ký của lô-->
            <mat-tab [label]="'title.config_signing_flow' | translate">
              <app-config-signing-flow-moha #configSign (getDefault)="getDefault($event)"
                                       (changeUseDataForTemplate)="useCreateSide($event)"
                                       (setUserSign)="setUserSign($event)"
                                       (DATA_RECORD_USER_PERFORM_SIGN)="setDataRecordUserPerformSign($event)"
                                       [data_foot_note]="dataFootNote"
                                       [record_party_sign]="contractLot && contractLot.enterpriseSign? contractLot.enterpriseSign: []"
                                       [record_user_perform_sign]="contractLot && contractLot.userSign? contractLot.userSign: dataUserSign"
                                       [disabled]="viewMode === 'view'"
                                       [selectedServiceType]="serviceType"
                                       [viewMode]="viewMode"
                                       (maxNumberOfCustomerInFlowOutput)="setMaxNumberOfPartner($event)"
              ></app-config-signing-flow-moha>
            </mat-tab>
            <!--Thiết lập cấu hình chân ký-->
            <mat-tab [label]="'title.set_up_signature_config' | translate">
              <app-signature-config-lot-moha #signatureConfig
                                        [data]="dataFootNote"
                                        [create_side]="createSide"
                                        [disabled]="viewMode === 'view'"
                                        [isHaveDeleteCreata]="isHaveDeleteCreata"
                                        [user_sign]="userSign"
                                        [DATA_RECORD_USER_PERFORM_SIGN]="DATA_RECORD_USER_PERFORM_SIGN"
                                        [maxNumberOfCustomerInFlow]="maxNumberOfCustomerInFlow">

              </app-signature-config-lot-moha>
            </mat-tab>
            <mat-tab [label]="'contract_share_partner.share_partner_config' | translate">
              <div style="padding: 0 24px;">
                <div class="mt-4 mb-2">{{'contract_share_partner.share_contracts_with_partners' | translate}}</div>
                <mat-divider style="left: auto"></mat-divider>
                <br/>
                <div class="w-100 ">
                  <form nz-frm>
                    <nz-table #editRowSharePartnerTable nzBordered [nzData]="RECORD_SHARE_PARTNER" [nzShowPagination]="false" [nzNoResult]="contentEmptyTable1"
                              [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                      <thead>
                      <tr>
                        <th class="text-center" nzWidth="25px">
                          {{
                            "view_document_information.table_headers.signingApostropheContractUnit.no"
                              | translate
                          }}
                        </th>
                        <th class="text-center" nzWidth="65%">
                          {{
                            "view_document_information.table_headers.signingApostropheContractUnit.member"
                              | translate
                          }}
                        </th>
                        <th class="text-center" nzWidth="200px">
                          {{ 'contract_share_partner.view_permission' | translate }}
                        </th>
                        <th class="text-center" *ngIf="!id"></th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr *ngFor="let data of editRowSharePartnerTable.data; let i = index" class="editable-row">
                        <!-- TT -->
                        <td class="text-center">{{ i + 1 }}</td>
                        <!-- Tên -->
                        <td class="word-break-line">
                          <div class="editable-cell d-flex align-items-center">
                            <div style="margin-right: 12px;">
                              <svg width="20" height="20" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" matTooltip="{{'contract_share_partner.customer_share' | translate}}">
                                <path d="M5.4001 3.60005C5.4001 4.07744 5.21046 4.53528 4.87289 4.87284C4.53532 5.21041 4.07749 5.40005 3.6001 5.40005C3.12271 5.40005 2.66487 5.21041 2.32731 4.87284C1.98974 4.53528 1.8001 4.07744 1.8001 3.60005C1.8001 3.12266 1.98974 2.66482 2.32731 2.32726C2.66487 1.98969 3.12271 1.80005 3.6001 1.80005C4.07749 1.80005 4.53532 1.98969 4.87289 2.32726C5.21046 2.66482 5.4001 3.12266 5.4001 3.60005ZM10.2001 3.60005C10.2001 3.83643 10.1535 4.07049 10.0631 4.28888C9.97262 4.50727 9.84004 4.7057 9.67289 4.87284C9.50574 5.03999 9.30731 5.17257 9.08893 5.26303C8.87054 5.35349 8.63648 5.40005 8.4001 5.40005C8.16372 5.40005 7.92965 5.35349 7.71127 5.26303C7.49288 5.17257 7.29445 5.03999 7.12731 4.87284C6.96016 4.7057 6.82757 4.50727 6.73711 4.28888C6.64666 4.07049 6.6001 3.83643 6.6001 3.60005C6.6001 3.12266 6.78974 2.66482 7.12731 2.32726C7.46487 1.98969 7.92271 1.80005 8.4001 1.80005C8.87749 1.80005 9.33533 1.98969 9.67289 2.32726C10.0105 2.66482 10.2001 3.12266 10.2001 3.60005ZM7.7581 10.2C7.7857 10.0038 7.8001 9.80405 7.8001 9.60005C7.80149 8.65736 7.48434 7.74186 6.9001 7.00205C7.35615 6.73875 7.87348 6.60013 8.40008 6.60013C8.92668 6.60012 9.44401 6.73873 9.90006 7.00203C10.3561 7.26533 10.7348 7.64403 10.9981 8.10008C11.2615 8.55612 11.4001 9.07345 11.4001 9.60005V10.2H7.7581ZM3.6001 6.60005C4.39575 6.60005 5.15881 6.91612 5.72142 7.47873C6.28403 8.04134 6.6001 8.8044 6.6001 9.60005V10.2H0.600098V9.60005C0.600098 8.8044 0.916168 8.04134 1.47878 7.47873C2.04139 6.91612 2.80445 6.60005 3.6001 6.60005Z" fill="black"/>
                              </svg>
                            </div>
                            <div class="row-icon"> {{ data?.name }} <span *ngIf="data.email"> - {{ data.email }}</span><span *ngIf="data.phone"> - {{ data.phone }}</span></div>
                          </div>
                        </td>
                        <td>
                          <div class="d-flex align-items-center justify-content-center cursor-pointer" [matMenuTriggerFor]="menuFeature" *ngIf="!id">
                            <div >
                              <span *ngIf="data.permission == 'FILE'">{{'contract_share_partner.view_file_contract' | translate}}</span>
                              <span *ngIf="data.permission == 'FULL'">{{'contract_share_partner.view_detail_contract' | translate}}</span>
                            </div>
                            <div>
                              <button mat-icon-button><mat-icon>keyboard_arrow_down</mat-icon></button>
                              <mat-menu #menuFeature="matMenu">
                                <button mat-menu-item (click)="data.permission = 'FILE'"  [ngClass]="{'active': data.permission == 'FILE'}">
                                  {{'contract_share_partner.view_file_contract' | translate}}
                                </button>
                                <button mat-menu-item (click)="data.permission = 'FULL'"  [ngClass]="{'active': data.permission == 'FULL'}">
                                  {{'contract_share_partner.view_detail_contract' | translate}}
                                </button>
                              </mat-menu>
                            </div>
                          </div>
                          <div *ngIf="id" class="text-center">
                            <span *ngIf="data.permission == 'FILE'">{{'contract_share_partner.view_file_contract' | translate}}</span>
                            <span *ngIf="data.permission == 'FULL'">{{'contract_share_partner.view_detail_contract' | translate}}</span>
                          </div>
                        </td>
                        <!-- Action -->
                        <td class="td-nz-icon text-center" *ngIf="!id">
                          <a nz-popconfirm [nzIcon]="iconDel" nzPopconfirmTitle="{{
                                  'contract_share_partner.confirm_delete_customer' | translate
                                }}" (nzOnConfirm)="onClickDeleteElementRecordParty(data.enterpriseId, data.customerId)"
                            nzCancelText="{{ 'button.cancel' | translate }}" nzOkText="{{ 'button.ok' | translate }}">
                            <i class="fa fa-trash" aria-hidden="true" matTooltip="{{ 'tooltips.delete' | translate }}"></i>
                          </a>
                          <ng-template #iconDel>
                            <i class="text-primary" nz-icon nzType="warning" nzTheme="outline"></i>
                          </ng-template>
                        </td>
                      </tr>
                      <tr class="editable-row" *ngIf="!id">
                        <!-- TT -->
                        <td class="text-center">&nbsp;</td>
                        <!-- Tên -->
                        <td colspan="3">
                          <div>
                            <nz-input-group [nzSuffix]="suffixPartyInput2">
                              <input nz-input [(ngModel)]="inputPartyValue" (input)="onChangePartySignSearch($event)"
                                    [nzAutocomplete]="autoPartySearching" [ngModelOptions]="{ standalone: true }" placeholder="{{
                                      'contract_share_partner.enter_partner_customer' | translate
                                    }}" #focusPartyInput id="inputParty" />
                              <nz-autocomplete #autoPartySearching>
                                <nz-auto-option *ngFor="let party of filteredPartyOptions" (selectionChange)="
                                        autocompletePartySelected($event, party)
                                      " [nzValue]="''">
                                  <div class="d-flex">
                                    <mat-icon class="mr-2">account_circle</mat-icon>
                                    <span style="line-height: 20px">
                                        {{ party.name }} -
                                      {{
                                        party.taxCode && party.taxCode.length > 0
                                          ? party.taxCode
                                          : party.certificateNo
                                      }}
                                      </span>
                                  </div>
                                  <div class="d-flex">
                                    <mat-icon class="mr-2">contact_mail</mat-icon>
                                    <span style="line-height: 20px">
                                        <span *ngIf="party.email">{{ party.email }} -</span>
                                      {{ party.phone }}
                                      </span>
                                  </div>
                                  <hr style="margin: 0; padding: 0" />
                                </nz-auto-option>
                              </nz-autocomplete>
                            </nz-input-group>
                            <ng-template #suffixPartyInput2>
                              <nz-spin *ngIf="nzCheckLoadingParty2" nzSimple [nzIndicator]="indicatorPartyInput2"></nz-spin>
                            </ng-template>
                            <ng-template #indicatorPartyInput2><i class="nz-icon-font" nz-icon nzType="loading"
                                                                style="font-size: 24px"></i>
                            </ng-template>
                          </div>
                        </td>
                        <!-- Thực hiện -->
                        <!--                      <td class="td-nz-icon text-center">&nbsp;</td>-->
                      </tr>
                      </tbody>
                    </nz-table>
                    <ng-template #contentEmptyTable1 ></ng-template>
                  </form>
                </div>
              </div>
            </mat-tab>
          </mat-tab-group>
        </mat-expansion-panel>

        <mat-expansion-panel expanded="true" class="mb-3" *ngIf="viewMode === 'view'" disabled>
          <mat-tab-group class="list-contract">
            <mat-tab label="{{ 'title.list_contract_create' | translate }}">
              <div class="row my-3" style="width: 100%">
                <div class="col-3 title-panel">

                </div>
                <div class="col-9 d-flex justify-content-between" *ngIf="processing">
                  <div class=" title-panel" style="font-size: 15px !important; font-weight: 600 !important;">{{ "contract_lot.contract_lot_processing" | translate }} ({{
                    processing.percent ? processing.percent : 0 }}%)</div>
                  <div class="d-flex flex-column justify-content-center" style="width: calc(100% - 200px);">
                    <mat-progress-bar mode="determinate" [value]="processing.percent" [bufferValue]="100">
                    </mat-progress-bar>
                  </div>
                </div>
              </div>
              <div class="contract-lot-detail">
                <div class="row">
                  <div class="col-12 d-flex justify-content-between">
                    <div>
                      <b>{{ "contract_lot.contract_lot_code" | translate }}:</b>
                      {{
                      contractLot && contractLot.code ? contractLot.code : null
                      }}
                    </div>
                    <div class="d-flex">
                      <div class="mr-4">
                        <b>{{ "contract_lot.total_contract" | translate }}:</b>
                        {{ renderNumber("total") }}
                      </div>
                      <div class="mr-4">
                        <b>{{ "contract_lot.contract_success" | translate }}:</b>
                        {{ renderNumber("success") }}
                      </div>
                      <div>
                        <b>{{ "contract_lot.contract_error" | translate }}:</b>
                        {{ renderNumber("error") }}
                      </div>
                    </div>
                  </div>
                  <div class="col-12 d-flex justify-content-between pt-4">
                    <p class="font-weight-bold">
                      {{ "contract_lot.result" | translate }}
                    </p>
                    <a class="file-result" *ngIf="!processing" (click)="getResultFile()">{{
                      "contract_lot.download_result_file" | translate
                      }}</a>
                  </div>
                  <div class="col-12">
                    <nz-table #rowsTable nzBordered [nzData]="contractLot.contractDetails" [nzShowPagination]="false"
                      [nzFrontPagination]="false" class="ant-table-no-placeholder-border-bottom">
                      <thead>
                        <tr>
                          <th class="text-center" nzWidth="55px">
                            {{ "contract_lot.table_detail.index" | translate }}
                          </th>
                          <!-- <th class="text-center" nzWidth="20%">
                            {{
                              "contract_lot.table_detail.customer_type" | translate
                            }}
                          </th> -->
                          <th class="text-center" nzWidth="8%">
                            {{ "contract_lot.table_detail.row" | translate }}
                          </th>
                          <th class="text-center" nzWidth="20%">
                            {{
                            "contract_lot.table_detail.contract_code" | translate
                            }}
                          </th>
                          <th class="text-center" nzWidth="20%">
                            {{
                            "contract_lot.table_detail.customer_name" | translate
                            }}
                          </th>
                          <th class="text-center" nzWidth="15%">
                            {{ "contract_lot.table_detail.status" | translate }}
                          </th>
                          <th class="text-center" nzWidth="35%">
                            {{
                            "contract_lot.table_detail.error_detail" | translate
                            }}
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let data of rowsTable.data; let i = index">
                          <td class="text-center">{{ i + 1 }}</td>
                          <!-- <td class="text-center">
                            <span *ngIf="data.customerType === 'PERSONAL'">{{
                              "contract_lot.customer_type.personal" | translate
                            }}</span>
                            <span *ngIf="data.customerType === 'ENTERPRISE'">{{
                              "contract_lot.customer_type.enterprise" | translate
                            }}</span>
                          </td> -->
                          <td class="text-center">
                            {{ data.orderNo ? data.orderNo : null }}
                          </td>
                          <td  nz-tooltip [nzTooltipTitle]="data.contractCode + ' - ' + data.contractName">
                            {{ data.contractCode ? (data.contractCode | slice:0:20) : null }}
                            <span *ngIf="data.contractCode && data.contractCode.length > 20">...</span>
                             - {{ data.contractName ? (data.contractName | slice:0:20) :null }}
                             <span *ngIf="data.contractName && data.contractName.length > 20">...</span>
                          </td>
                          <td nz-tooltip  [nzTooltipTitle]="data.customerName">
                            {{ data.customerName ? (data.customerName | slice:0:30) : null }}<span
                              *ngIf="data.customerName && data.customerName.length > 30">...</span>
                          </td>
                          <td [ngStyle]="renderStatusColor(data.status)">
                            {{ renderStatus(data.status) }}
                          </td>
                          <td nz-tooltip  [nzTooltipTitle]="data.errorMessage">
                            {{ data.errorMessage ? (data.errorMessage| slice:0:40) : null }}<span
                              *ngIf="data.errorMessage && data.errorMessage.length > 40">...</span>
                          </td>
                        </tr>
                      </tbody>
                    </nz-table>
                  </div>
                </div>
              </div>
            </mat-tab>
            <mat-tab  label="{{ 'title.info_cotract_report_list' | translate }}">
              <div class="contract-lot-detail">
                <p style="font-weight: 700; font-size: 16px; margin-top: 24px;">{{'contract_lot.result' | translate}}</p>
                <nz-table class="mt-2" *ngIf="tableData && dynamicColumns && tableData.length > 0 && dynamicColumns.length > 0; else noRecord"
                  #basicTable [nzShowPagination]="false" [nzData]="tableData"
                  [nzBordered]="true" [nzScroll]="{ x: 'max-content' }">
                  <thead>
                    <tr class="lot-group-header-row">
                      <!-- Ô nhóm trống cho các cột cố định -->
                      <th colspan="4"></th>
                      <!-- Header nhóm cho cột động -->
                      <th class="lot-group-cell text-center" *ngFor="let groupName of lotGroupRowColumns; let i = index"
                        [attr.colspan]="lotGroupColumns[i].span">
                        {{ lotGroupColumns[i].name }}
                      </th>
                    </tr>
                    <tr>
                      <!-- Cột cố định -->
                      <th class="text-center">STT</th>
                      <th class="text-center">
                        {{ 'add_document_moha.contract_code' | translate }}
                      </th>
                      <th class="text-center">
                        {{ 'add_document_moha.contract_name' | translate }}
                      </th>
                      <th class="text-center">
                        {{ 'add_document_moha.labor_contract_type' | translate }}
                      </th>
                      <!-- <th class="text-center">
                        {{ 'add_document_moha.UUID' | translate }}
                      </th> -->
                      <!-- Cột động -->
                      <th style="max-width: 250px;" class="text-center" *ngFor="let col of dynamicColumns">
                        {{ col.name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let row of tableData; let i = index;">
                      <!-- Data cố định -->
                      <td class="text-center">{{i + 1}}</td>
                      <td style="max-width: 250px;">
                        {{ row.contractCode }}
                      </td>
                      <td style="max-width: 250px;">
                        {{ row.contractName }}
                      </td>
                      <td style="max-width: 250px;">
                        {{ row.serviceTypeName }}
                      </td>
                      <!-- <td style="max-width: 250px;">
                        {{ row.contractMohaUuid }}
                      </td> -->
                      <!-- Data động -->
                      <td style="max-width: 250px;" *ngFor="let col of row.reportFields"
                        [matTooltip]="col.inputType !== 'DATETIME'
                          ? col.value
                          : (col.value | date: 'dd/MM/yyyy')">
                        <div *ngIf="col.inputType !== 'DATETIME'">
                          {{ col.value }}
                        </div>
                        <div class="text-center" *ngIf="col.inputType === 'DATETIME'">
                          {{ col.value | date: 'dd/MM/yyyy' }}
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </nz-table>
                <ng-template #noRecord>
                  <div class="text-center mb-2">{{ 'user_group.no_result' | translate}}</div>
                </ng-template>
              </div>
            </mat-tab>
          </mat-tab-group>

        </mat-expansion-panel>

        <div class="pr-0 fixed-bottom">
          <div class="bg-white text-center mat-elevation-z0 py-2 w-100" style="height: 60px">
            <button id="btn-cancel" mat-stroked-button color="primary" class="mr-3" type="button"
              *ngIf="viewMode === 'create'" (click)="onClickCancel()">
              <mat-icon class="mr-0">cancel</mat-icon>
              {{ "button.cancel" | translate }}
            </button>
            <button mat-raised-button color="primary" class="mr-3" type="button" (click)="submit()"
              *ngIf="viewMode === 'create'" [disabled]="!fileName || configSignComponent.checkOrder || configSignComponent.checkOrderUserSign()">
              <mat-icon class="mr-0">save</mat-icon>
              {{ "button.create_lot" | translate }}
            </button>
          </div>
        </div>
      </mat-accordion>
    </mat-card-content>
  </form>
</mat-card>
